import { getUserMessageSum, getUserMessagePage, markMessageHaveRead, markMessageHaveReadAll } from '@/api/system/messageCenter/messageCenter'

const message = {
  state: {
    waitReadCount: 0,
		toDoFiveList: [],
		busFiveList: [],
		sysFiveList: [],
  },
  mutations: {
    SET_WAIT_READ_COUNT: (state, waitReadCount) => {
      state.waitReadCount = waitReadCount
    },
		SET_TODO_LIST: (state, toDoFiveList) => {
		  state.toDoFiveList = toDoFiveList
		},
		SET_BUS_LIST: (state, busFiveList) => {
		  state.busFiveList = busFiveList
		},
		SET_SYS_LIST: (state, sysFiveList) => {
		  state.sysFiveList = sysFiveList
		},
  },
  actions: {
		// 获取消息（未读消息、todo、bus、sys前5条消息）
		getMessageInfo({ dispatch, commit }, messageType = "ALL") {
			// 获取未读消息数量
			dispatch("getWaitReadCount")
			// 获取前五条待办消息
			if(messageType == "ALL" || messageType == "TO_DO") dispatch("getFiveList", "TO_DO")
			if(messageType == "ALL" || messageType == "BUS") dispatch("getFiveList", "BUS")
			if(messageType == "ALL" || messageType == "SYS") dispatch("getFiveList", "SYS")
		},
		// 获取未读消息数量
    getWaitReadCount({ commit }) {
			return new Promise((resolve, reject) => {
				getUserMessageSum().then(res => {
					let unreadCount = parseInt(res.unreadCount) || 0
					commit( "SET_WAIT_READ_COUNT",unreadCount)
					resolve(unreadCount)
				}).catch(error => {
					reject(error)
				})
			}) 
    },
		// 获取前5条消息列表
		getFiveList({commit}, messageType) {
			return new Promise((resolve, reject) => {
				const params = {page: 1, size: 5, messageType}
				getUserMessagePage(params).then(res => {
					const list = res.records || []
					const setProp = messageType == "TO_DO"? "SET_TODO_LIST" : (messageType == "BUS"? "SET_BUS_LIST" : "SET_SYS_LIST")
					commit(setProp, list)
					resolve(list)
				}).catch(error => {
					reject(error)
				})
			}) 
		},
		// 标记已读(用于单个消息)
		markMessageHaveRead({dispatch, commit}, id, messageType = "ALL") {
			return new Promise((resolve, reject) => {
				markMessageHaveRead(id).then(res => {
					// 刷新相应消息数据
					dispatch("getMessageInfo", messageType)
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			}) 
		},
		// 全部标记已读
		markMessageHaveReadAll({dispatch, commit}, params) {
			return new Promise((resolve, reject) => {
				markMessageHaveReadAll(params).then(res => {
					// 刷新消息数据
					dispatch("getMessageInfo")
					resolve(res)
				}).catch(error => {
					reject(error)
				})
			}) 
		},
  }
}


export default message
